// extracted by mini-css-extract-plugin
export default {"footerContainer":"FooterButton_footerContainer__-AsXl"};